/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisibilityEnum } from './visibility-enum';
import { Label } from './label';
import { DeckCompanySimple } from './deck-company-simple';

export interface DeckPitch {
  readonly id: string;
  readonly name: string;
  readonly company: DeckCompanySimple;
  readonly total_raised: number;
  readonly number_of_investors: number;
  readonly min_goal: string | null;
  readonly max_goal: string | null;
  /**
   * Pitches are closed every half hour
   */
  readonly end_day: string | null;
  /**
   * public - visible for every user; unlisted - accessible only from direct link; private - visible only for admins; coming up - visible but not accessible;draft -
   */
  readonly visibility: VisibilityEnum;
  readonly share_price: string | null;
  readonly featured: boolean;
  readonly first_end_date: string | null;
  readonly start_date: string | null;
  readonly labels: Array<Label>;
  readonly homepage: string | null;
  readonly tax_deducted: boolean | null;
}
export namespace DeckPitch {}
